<template>
  <div class="wrapper">
    <core-app-bar />
    <core-drawer />
    <core-view />
    <core-footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  middleware: 'auth',
  components: {
    CoreDrawer: () => import('@/components/core/Drawer'),
    CoreFooter: () => import('@/components/core/Footer'),
    CoreAppBar: () => import('@/components/core/AppBar'),
    CoreView: () => import('@/components/core/View'),
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    ...mapGetters(['loggedInUser']),
  },
  mounted() {
    this.checkRole()
    this.loadTawkTo()
  },
  methods: {
    checkRole() {
      if (
        this.loggedInUser?.role_id !== 'ejqKOQMx7bgdWoJtAon5sw9SLEVpnV1JPZxMJTXj7fMy9YPgrNQPSwX02i-ddKGp3zYwy-BTQ-HtVoHHWbVCYw' &&
        this.loggedInUser?.is_staff === false
      ) {
        this.$router.push('/').catch(() => {})
      }
    },
    loadTawkTo() {
      // Check if Tawk.to is configured
      const tawkToSrc = process.env.tawkToSrc
      if (!tawkToSrc) {
        // Tawk.to not configured, skip loading
        return
      }

      // Check if already loaded
      if (typeof window !== 'undefined' && window.Tawk_API) {
        return
      }

      // Load Tawk.to script
      const script = document.createElement('script')
      script.async = true
      script.src = tawkToSrc
      script.charset = 'UTF-8'
      script.setAttribute('crossorigin', '*')
      document.body.appendChild(script)
    },
  },
  head: {
    bodyAttrs: {
      class: '',
    },
  },
}
</script>
